
import Vue from 'vue';
import ContactUsForm from '../components/ContactUsForm.vue';
import { ACTIONS } from '../constants/actions';
export default Vue.extend({
  components: { ContactUsForm },
  name: 'ContactUs',
  methods: {
    submitContactUs(): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.contactUs.formSubmit).then(() => {
        dispatch(ACTIONS.contactUs.resetFormValues);
      });
    }
  }
});
